import type { RelayRole } from '@/atoms/memberships'

export default function RolePill({ role }: { role: RelayRole }) {
  const hue = role.color ? Number(role.color) : null
  const style: React.CSSProperties =
    hue !== null && Number.isFinite(hue)
      ? {
          backgroundColor: `hsl(${hue}, 60%, 95%)`,
          color: `hsl(${hue}, 60%, 30%)`,
          borderColor: `hsl(${hue}, 60%, 80%)`
        }
      : {}
  return (
    <span
      className="inline-flex items-center px-1.5 h-4 rounded-md text-[10px] font-medium border border-transparent leading-none"
      style={style}
      title={role.description}
    >
      {role.label || role.id}
    </span>
  )
}
